import Player from "../../components/courses/Player";
import VideoList from "../../components/courses/VideoList";


export default function Courses() {


  return (
    <section className="py-6 bg-primary">
      <div className="mx-auto max-w-7xl px-5 lg:px-0">
        <div className="grid grid-cols-3 gap-2 lg:gap-8">
          <Player />
          <VideoList />
        </div>
      </div>
    </section>
  )
};